var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgActivationNav = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2,18.8c-0.3,0-0.5-0.2-0.5-0.5c0-2.9-3-5.3-6.7-5.3c-3.7,0-6.7,2.4-6.7,5.3c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5 c0-3.5,3.4-6.3,7.7-6.3s7.7,2.8,7.7,6.3C17.7,18.6,17.4,18.8,17.2,18.8z M10,10.5c-1.2,0-2.4-0.5-3.3-1.4C5.8,8.3,5.3,7.1,5.3,5.8 c0-1.2,0.5-2.4,1.4-3.3C7.6,1.7,8.8,1.2,10,1.2c1.2,0,2.4,0.5,3.3,1.4c0.9,0.9,1.4,2.1,1.4,3.3c0,1.2-0.5,2.4-1.4,3.3 C12.4,10,11.2,10.5,10,10.5z M10,2.2c-1,0-1.9,0.4-2.6,1.1C6.7,3.9,6.3,4.9,6.3,5.8c0,1,0.4,1.9,1.1,2.6c1.4,1.4,3.8,1.4,5.2,0 c0.7-0.7,1.1-1.6,1.1-2.6c0-1-0.4-1.9-1.1-2.6C11.9,2.5,11,2.2,10,2.2z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgActivationNav, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/activation-nav.3f03ec71.svg";
export { ForwardRef as ReactComponent };